<template>
  <router-link class="top-article-box" :to="getJumpWikiDetailUrl(item.game.alias, item.game.id, item.id, true)">
    <div class="header">
      <template>
        <img v-lazy="handleImgSize(calcImgList, 'list')" class="bg-img" alt="" />
      </template>
      <div class="top-btn">
        编辑推荐
      </div>
      <div class="article-title">
        <div class="main-title" v-html="xss(item.title)" />
      </div>
    </div>
    <div class="user-line">
      <span class="user">
        <img v-lazy="handleImgSize(item.user.avatar, 'mini')" alt="" />
        <span class="name">{{ item.user.username }}</span>
      </span>
      <div class="info"><i class="iconfont icon-pinglun" /> {{ item.comment_count }}</div>
    </div>
  </router-link>
</template>
<script>
import { getJumpWikiDetailUrl } from "@/plugins/util";
export default {
  name: "topArticle",
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    calcImgList() {
      return this.item.thumb ? this.item.thumb.split(",")[0] : null;
    }
  },
  methods: {
    getJumpWikiDetailUrl
  }
};
</script>
<style lang="less" scoped>
.top-article-box {
  display: block;
  margin-bottom: 15px;
  background-color: rgba(248, 249, 249, 0.66);
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 4px;
  .header {
    position: relative;
    width: 100%;
    height: 136px;
    box-sizing: border-box;
    .bg-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .top-btn {
      position: absolute;
      top: 8px;
      left: 8px;
      height: 20px;
      padding: 3px 14px;
      line-height: 14px;
      color: #fff;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.6);
      border-radius: 12px;
    }
    .article-title {
      display: flex;
      position: absolute;
      align-items: flex-end;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 53px;
      padding: 0 8px 10px 8px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #fff;
      font-weight: 500;
      font-size: 14px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
      .main-title {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .user-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
    padding: 0 8px;
    border-bottom: 1px solid #eaeaea;
    .user {
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 8px;
      }
      .name {
        color: #666;
        font-size: 12px;
      }
    }
    .info {
      color: #666;
      font-size: 12px;
    }
  }
}
</style>
